/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsmodelabel3Inputs */

const en_listingbuttonsmodelabel3 = /** @type {(inputs: Listingbuttonsmodelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choice of buttons`)
};

const de_listingbuttonsmodelabel3 = /** @type {(inputs: Listingbuttonsmodelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl der Knöpfe`)
};

/**
* | output |
* | --- |
* | "Choice of buttons" |
*
* @param {Listingbuttonsmodelabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsmodelabel3 = /** @type {((inputs?: Listingbuttonsmodelabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsmodelabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsmodelabel3(inputs)
	return de_listingbuttonsmodelabel3(inputs)
});
export { listingbuttonsmodelabel3 as "listingButtonsModeLabel" }